import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getTimeSheetCountsByStatusAsync, getTimeSheetForAdminUsingStatus, GetTimeSheetsByMonthYearAndAssignmentIdAsync, uploadMonthlyTimeSheetAsync } from './timeSheetThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const timeSheetStateSlice = createSlice({
    name: 'timeSheet',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GetTimeSheetsByMonthYearAndAssignmentIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(GetTimeSheetsByMonthYearAndAssignmentIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.timeSheetWrtAssignment = action.payload;
        })
            .addCase(GetTimeSheetsByMonthYearAndAssignmentIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTimeSheetForAdminUsingStatus.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getTimeSheetForAdminUsingStatus.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.timeSheetWithClientInfo = action.payload;
        })
            .addCase(getTimeSheetForAdminUsingStatus.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(uploadMonthlyTimeSheetAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(uploadMonthlyTimeSheetAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(uploadMonthlyTimeSheetAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getTimeSheetCountsByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getTimeSheetCountsByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.timeSheetsCount = action.payload;
        })
            .addCase(getTimeSheetCountsByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default timeSheetStateSlice.reducer;
